document.addEventListener('DOMContentLoaded', function() {
  const dropHintPopup = document.getElementById('drop-hint-popup');
  const openTrigger = document.querySelector('.open-drop_hint_button__trigger');
  const closeButton = document.querySelector('.drop-hint-popup__close');
  const overlay = document.querySelector('.drop-hint-popup__overlay');


  // Mở popup khi click vào trigger button
  if (openTrigger) {
    openTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      if (dropHintPopup) {
        dropHintPopup.classList.add('active');
        syncHintNames();
      }
    });
  }

  // Đóng popup khi click vào nút close
  if (closeButton) {
    closeButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (dropHintPopup) {
        dropHintPopup.classList.remove('active');
      }
    });
  }

  // Đóng popup khi click vào overlay (ra ngoài popup)
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (dropHintPopup) {
        dropHintPopup.classList.remove('active');
      }
    });
  }

  // Đóng popup khi click ra ngoài popup content
  if (dropHintPopup) {
    dropHintPopup.addEventListener('click', function(e) {
      // Chỉ đóng nếu click vào chính popup container, không phải popup content
      if (e.target === dropHintPopup) {
        dropHintPopup.classList.remove('active');
      }
    });
  }

  // Đóng popup khi nhấn phím ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && dropHintPopup && dropHintPopup.classList.contains('active')) {
      dropHintPopup.classList.remove('active');
    }
  });




  const hintRecipientName = document.getElementById('hintRecipientName');
  const hintSenderName = document.getElementById('hintSenderName');
  const emptyName = '_________';

  // Powerful Form Builder generates its own field IDs, so identify these two
  // fields by their configured labels/placeholders instead of the old Gravity
  // Forms IDs (input_6_1 and input_6_5).
  function getFieldDescription(input) {
    const control = input.closest('.globo-form-control');
    const label = control ? control.querySelector('label') : null;

    return [
      input.placeholder,
      input.getAttribute('aria-label'),
      input.name,
      label ? label.textContent : ''
    ].filter(Boolean).join(' ').toLowerCase().replace(/[’']/g, '');
  }

  function getHintField(input) {
    if (!(input instanceof HTMLInputElement) || input.type !== 'text') return null;

    const description = getFieldDescription(input);
    if (/recipient.*(first\s*)?name/.test(description)) return 'recipient';
    if (/(your|sender).*(first\s*)?name/.test(description)) return 'sender';
    return null;
  }

  function updateHintName(input) {
    const field = getHintField(input);
    if (!field) return;

    const value = input.value.trim() || emptyName;

    if (field === 'recipient' && hintRecipientName) hintRecipientName.textContent = value;
    if (field === 'sender' && hintSenderName) hintSenderName.textContent = value;
  }

  function syncHintNames() {
    if (!dropHintPopup) return;

    const fieldPlaceholders = [
      "Recipient's First Name",
      "Recipient's Email",
      'Your First Name',
      'Your Email'
    ];

    dropHintPopup.querySelectorAll('.globo-formbuilder input[type="text"], .globo-formbuilder input[type="email"]').forEach(function(input, index) {
      const control = input.closest('.globo-form-control');

      if (control) control.classList.add('drop-hint-field');
      if (fieldPlaceholders[index]) input.placeholder = fieldPlaceholders[index];

      updateHintName(input);
    });

    dropHintPopup.querySelectorAll('.globo-formbuilder button[type="submit"], .globo-formbuilder input[type="submit"]').forEach(function(button) {
      if (button.tagName === 'INPUT') button.value = 'SEND';
      else button.textContent = 'SEND';
    });
  }

  if (dropHintPopup) {
    // Delegation also handles fields that the app injects after DOMContentLoaded.
    ['input', 'change'].forEach(function(eventName) {
      dropHintPopup.addEventListener(eventName, function(e) {
        updateHintName(e.target);
      });
    });

    const observer = new MutationObserver(function(mutations) {
      const formFieldWasAdded = mutations.some(function(mutation) {
        return Array.from(mutation.addedNodes).some(function(node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;

          return node.matches('.globo-formbuilder input[type="text"]') ||
            node.querySelector('.globo-formbuilder input[type="text"], input[type="text"]');
        });
      });

      if (formFieldWasAdded) syncHintNames();
    });
    observer.observe(dropHintPopup, { childList: true, subtree: true });
    syncHintNames();
  }

});
